import React, { Component } from 'react';
import ReactDOM from 'react-dom';
import { Row, Col, Button, Collapse } from 'react-bootstrap';
import Moment from 'moment';
import $ from 'jquery';
import FlightAutocomplete from './flightAutocomplete/FlightAutocomplete';
import TypeTrip from './typeTrip/TypeTrip';
import Calendar from './calendar/Calendar';
import PassengerCounter from './passengerCounter/PassengerCounter';
import SelectBox from './../common/selectBox/SelectBox';
import InfoModal from './infoModal/InfoModal';
import TypeOfFlight from './typeOfFlight/TypeOfFlight';
import CompaniesIdentity from './companiesIdentity/CompaniesIdentity';
import PropTypes from 'prop-types';
import RecentSearch from './recentSearch/RecentSearch';
import './SearchBox.css';
import FlightSearchValidation from '../../services/validation/FlightSearchValidation';
import FeatureService from '../../services/feature/FeatureService';
import Features from '../../const/Features';
import AirCompanyService from '../../services/airCompany/AirCompanyService';

const I18n = require('i18n-react').default;

let ECONOMY_LABEL, BUSINESS_LABEL;

const cabinType = {
  ECONOMY: 'ECONOMY',
  BUSINESS: 'BUSINESS'
};

const defaultProps = {
  typeTrip: 'roundTrip',
  flightOrigin: null,
  flightDestiny: null,
  startDate: null,
  endDate: null,
  totalAdults: Number(1),
  totalKids: Number(0),
  totalBabys: Number(0),
  cabinCategory: 'ECONOMY',
  recentFlights: [],
  companiesIdentity: '',
  typeOfFlight: 'A'
};

const propTypes = {
  typeTrip: PropTypes.string,
  flightOrigin: PropTypes.object,
  flightDestiny: PropTypes.object,
  startDate: PropTypes.string,
  endDate: PropTypes.string,
  totalAdults: PropTypes.number,
  totalKids: PropTypes.number,
  totalBabys: PropTypes.number,
  cabinCategory: PropTypes.string,
  searchCallback: PropTypes.func,
  recentFlights: PropTypes.arrayOf(
    PropTypes.shape({
      flightOrigin: PropTypes.shape({
        code: PropTypes.string.isRequired
      }).isRequired,
      flightDestiny: PropTypes.shape({
        code: PropTypes.string.isRequired
      }).isRequired,
      typeTrip: PropTypes.string.isRequired,
      startDate: PropTypes.string.isRequired,
      endDate: PropTypes.string,
      totalAdults: PropTypes.number.isRequired,
      totalKids: PropTypes.number.isRequired,
      totalBabys: PropTypes.number.isRequired,
      typeOfFlight: PropTypes.string
    })
  ),
  handleAirportSearch: PropTypes.func.isRequired,
  clickRecentSearch: PropTypes.func,
  typeOfFlight: PropTypes.string,
  companiesIdentity: PropTypes.string
};

class SearchBox extends Component {
  constructor(props) {
    super(props);

    window.GlobalMem = window.GlobalMem || { companiesList: [] };

    ECONOMY_LABEL = I18n.translate('components.flight.economy');
    BUSINESS_LABEL = I18n.translate('components.flight.business');

    this.state = {
      typeTrip: props.typeTrip,
      flightOrigin: props.flightOrigin,
      flightDestiny: props.flightDestiny,
      minSelectionDate: Moment()
        .startOf('day')
        .add(4, 'day')
        .toISOString(),
      maxSelectionDate: Moment()
        .startOf('day')
        .add(345, 'day')
        .toISOString(),
      startDate: props.startDate,
      endDate: props.endDate,
      totalAdults: props.totalAdults,
      totalKids: props.totalKids,
      totalBabys: props.totalBabys,
      openModal: false,
      showAdditionalFields: false,
      featureHomeValidationService: false,
      selectCabinCategory: ECONOMY_LABEL,
      cabinCategory: cabinType.ECONOMY,
      typeOfFlight: props.typeOfFlight,
      companiesList: window.GlobalMem.companiesList,
      companiesIdentity: props.companiesIdentity
    };

    this.setTypeTrip = this.setTypeTrip.bind(this);
    this.setFlightOrigin = this.setFlightOrigin.bind(this);
    this.setFlightDestiny = this.setFlightDestiny.bind(this);
    this.handlerStartDate = this.handlerStartDate.bind(this);
    this.handlerFocusStartDate = this.handlerFocusStartDate.bind(this);
    this.handlerEndDate = this.handlerEndDate.bind(this);
    this.setAdultPassengerCounter = this.setAdultPassengerCounter.bind(this);
    this.setBabyPassengerCounter = this.setBabyPassengerCounter.bind(this);
    this.setKidPassengerCounter = this.setKidPassengerCounter.bind(this);

    this.showModal = this.showModal.bind(this);
    this.closeModal = this.closeModal.bind(this);
    this.searchTicket = this.searchTicket.bind(this);

    this.validateSearchRules = this.validateSearchRules.bind(this);
    this.validatePassengerSum = this.validatePassengerSum.bind(this);
    this.validateBabysGreaterThanAdults = this.validateBabysGreaterThanAdults.bind(this);
    this.validateStartDateBeforeMinDate = this.validateStartDateBeforeMinDate.bind(this);
    this.validateEndDateBeforeMinDate = this.validateEndDateBeforeMinDate.bind(this);
    this.validateEndDateBeforeStartDate = this.validateEndDateBeforeStartDate.bind(this);
    this.validateStartDateAfterMaxDate = this.validateStartDateAfterMaxDate.bind(this);
    this.validateEndDateAfterMaxDate = this.validateEndDateAfterMaxDate.bind(this);
    this.validateEmptyFields = this.validateEmptyFields.bind(this);

    this.setCompaniesIdentity = this.setCompaniesIdentity.bind(this);
    this.setTypeOfFlight = this.setTypeOfFlight.bind(this);
    this.onTouched = this.onTouched.bind(this);
    this.toggleCollapse = this.toggleCollapse.bind(this);
  }

  componentWillMount() {
    if (this.props.flightOrigin) {
      this.setState({
        showAdditionalFields: true
      });
    }

    FeatureService.isFeatureEnabled(Features.HOME_VALIDATION_SERVICE).then(isEnabled => {
      this.setState({
        featureHomeValidationService: isEnabled
      });
    });

    this.loadAirCompanyList();
  }

  loadAirCompanyList() {
    AirCompanyService.getAirCompanytList().then(response => {
      var airCompanyList = [];
      response.data.forEach(element => {
        let airCompany = {
          id: element.code,
          name: I18n.translate('company.' + element.code)
        };
        airCompanyList.push(airCompany);
      });
      airCompanyList.sort(function(a, b) {
        if (a.name > b.name) {
          return 1;
        }
        if (a.name < b.name) {
          return -1;
        }
        // a must be equal to b
        return 0;
      });
      window.GlobalMem.companiesList = airCompanyList;
      this.setState({
        companiesList: airCompanyList
      });
    });
  }

  componentDidMount() {
    this.listenerShowAdditionalFields(this.flightOrigin.refs.autocompleteFlightOrigin.refs.input);
    this.listenerShowAdditionalFields(
      this.flightDestination.refs.autocompleteFlightDestination.refs.input
    );
  }

  componentWillReceiveProps(nextProps) {
    const showAdditionalFields = nextProps.flightOrigin ? true : false;

    this.setState({
      typeTrip: nextProps.typeTrip,
      flightOrigin: nextProps.flightOrigin,
      flightDestiny: nextProps.flightDestiny,
      startDate: nextProps.startDate,
      endDate: nextProps.endDate,
      totalAdults: nextProps.totalAdults,
      totalKids: nextProps.totalKids,
      totalBabys: nextProps.totalBabys,
      cabinCategory: nextProps.cabinCategory,
      selectCabinCategory:
        nextProps.cabinCategory === cabinType.ECONOMY ? ECONOMY_LABEL : BUSINESS_LABEL,
      showAdditionalFields: showAdditionalFields,
      isTouched: false,
      openCollapse: false,
      typeOfFlight: nextProps.typeOfFlight,
      companiesIdentity: nextProps.companiesIdentity
    });
  }

  listenerShowAdditionalFields(element) {
    const _this = this;
    if (!_this.state.showAdditionalFields) {
      ReactDOM.findDOMNode(element).addEventListener('focus', () => {
        this.setState({
          showAdditionalFields: true
        });
      });
    }
  }

  setTypeOfFlight(value) {
      this.setState({
        typeOfFlight: value
      });
  }

  setCompaniesIdentity(value) {
    this.setState({
      companiesIdentity: value
    });
  }

  setTypeTrip(value) {
    this.setState({
      typeTrip: value,
      endDate: value === 'oneWay' ? null : this.state.endDate,
      showAdditionalFields: true
    });
  }

  setFlightOrigin(value) {
    this.setState({
      flightOrigin: value,
      showAdditionalFields: true
    });
    $('input#autocompleteFlightDestination').focus();
  }

  setFlightDestiny(value) {
    this.setState({
      flightDestiny: value
    });
    $('#calendarStartDate_group input').focus();
  }

  handlerFocusStartDate() {
    if (!this.state.startDate) {
      this.setState({
        startDate: this.state.minSelectionDate
      });
    }
  }

  handlerStartDate(value) {
    this.setState({
      startDate: value
    });
    if (this.state.typeTrip === 'roundTrip' && value && value.length > 0) {
      this.setState({
        endDate: value
      });
      this.startDate.refs.calendarStartDate.state.focused = false;
      setImmediate(() => {
        $('#calendarEndDate_group input').focus();
      });
    }
  }

  handlerEndDate(value) {
    this.setState({
      endDate: value
    });
  }

  setAdultPassengerCounter(value) {
    this.setState({
      totalAdults: Number(value)
    });
  }

  setKidPassengerCounter(value) {
    this.setState({
      totalKids: Number(value)
    });
  }

  setBabyPassengerCounter(value) {
    this.setState({
      totalBabys: Number(value)
    });
  }

  showModal(message) {
    this.setState({
      openModal: true,
      messageInfo: message
    });
  }

  closeModal() {
    this.setState({
      openModal: false,
      messageInfo: null
    });
  }

  searchTicket() {
    if (this.state.featureHomeValidationService) {
      this.searchTicketWithValidationService();
    } else if (this.validateSearchRules()) {
      this.props.searchCallback(this.state);
    }
  }

  searchTicketWithValidationService() {
    const validation = FlightSearchValidation.validateSearchRules(this.state);
    if (validation.hasValidSearch) {
      this.props.searchCallback(this.state);
    } else {
      this.showModal(I18n.translate(validation.message.code, validation.message));
    }
  }

  validateSearchRules() {
    var hasValidSearch = true;

    const emptyField = this.validateEmptyFields();
    if (emptyField) {
      hasValidSearch = false;
      this.showModal(I18n.translate('home.msg.emptyField.' + emptyField));
    }

    if (hasValidSearch && this.validatePassengerSum()) {
      hasValidSearch = false;
      this.showModal(I18n.translate('home.msg.qtdPassengerGraterThanMax'));
    }

    if (hasValidSearch && this.validateBabysGreaterThanAdults()) {
      hasValidSearch = false;
      this.showModal(I18n.translate('home.msg.qtdBabyGraterThanAdults'));
    }

    if (hasValidSearch) {
      hasValidSearch = this.validateDateRules();
    }

    return hasValidSearch;
  }

  validateDateRules() {
    var hasValidSearch = true;

    hasValidSearch = this.validateStartDateRules();

    if (hasValidSearch) {
      hasValidSearch = this.validateEndDateRules();
    }

    if (hasValidSearch && this.validateEndDateBeforeStartDate()) {
      hasValidSearch = false;
      this.showModal(I18n.translate('home.msg.endDateBeforeStartDate'));
    }

    return hasValidSearch;
  }

  validateStartDateRules() {
    var hasValidSearch = true;

    if (this.validateStartDateBeforeMinDate()) {
      hasValidSearch = false;
      this.showModal(
        I18n.translate('home.msg.startDateBeforeMinDate', {
          date: Moment(this.state.minSelectionDate)
            .subtract(1, 'days')
            .format('DD/MM/YYYY')
        })
      );
    }

    if (hasValidSearch && this.validateStartDateAfterMaxDate()) {
      hasValidSearch = false;
      this.showModal(
        I18n.translate('home.msg.startDateAfterMaxDate', {
          date: Moment(this.state.maxSelectionDate)
            .add(1, 'days')
            .format('DD/MM/YYYY')
        })
      );
    }

    return hasValidSearch;
  }

  validateEndDateRules() {
    var hasValidSearch = true;

    if (this.validateEndDateBeforeMinDate()) {
      hasValidSearch = false;
      this.showModal(
        I18n.translate('home.msg.endDateBeforeMinDate', {
          date: Moment(this.state.minSelectionDate)
            .subtract(1, 'days')
            .format('DD/MM/YYYY')
        })
      );
    }

    if (hasValidSearch && this.validateEndDateAfterMaxDate()) {
      hasValidSearch = false;
      this.showModal(
        I18n.translate('home.msg.endDateAfterMaxDate', {
          date: Moment(this.state.maxSelectionDate)
            .add(1, 'days')
            .format('DD/MM/YYYY')
        })
      );
    }

    return hasValidSearch;
  }

  validateEmptyFields() {
    var fields = ['flightOrigin', 'flightDestiny', 'startDate'];
    if (this.state.typeTrip === 'roundTrip') {
      fields.push('endDate');
    }

    var emptyField;
    for (var i = 0; i++; i < fields.length) {
      if (!this.state[fields[i]]) {
        emptyField = fields[i];
        break;
      }
    }

    return emptyField;
  }

  validatePassengerSum() {
    return this.state.totalAdults + this.state.totalBabys + this.state.totalKids > 9;
  }

  validateBabysGreaterThanAdults() {
    return this.state.totalBabys > this.state.totalAdults;
  }

  validateStartDateBeforeMinDate() {
    return Moment(this.state.startDate).isBefore(Moment(this.state.minSelectionDate));
  }

  validateEndDateBeforeMinDate() {
    return Moment(this.state.endDate).isBefore(Moment(this.state.minSelectionDate));
  }

  validateEndDateBeforeStartDate() {
    return Moment(this.state.endDate).isBefore(Moment(this.state.startDate));
  }

  validateStartDateAfterMaxDate() {
    return Moment(this.state.startDate).isAfter(Moment(this.state.maxSelectionDate));
  }

  validateEndDateAfterMaxDate() {
    return Moment(this.state.endDate).isAfter(Moment(this.state.maxSelectionDate));
  }

  changeValue = value => {
    this.setState({
      selectCabinCategory: value,
      cabinCategory: value === ECONOMY_LABEL ? cabinType.ECONOMY : cabinType.BUSINESS
    });
  };

  renderRecentSearch() {
    if (this.props.recentFlights.length) {
      return (
        <Col xs={12} md={6}>
          <RecentSearch
            flights={this.props.recentFlights}
            clickCallback={this.props.clickRecentSearch}
          />
        </Col>
      );
    }
  }

  toggleCollapse() {
    this.setState(state => ({ openCollapse: !state.openCollapse }));
  }

  renderTypeTripAndRecentSearchTabletDesktop() {
    return (
      <Row className="row-type-trip">
        <Col xs={12} md={6} className="first-column">
          <TypeTrip
            id="typeTrip"
            callbackOnClick={this.setTypeTrip}
            active={this.state.typeTrip}
            ref={e => (this.typeTrip = e)}
          />
        </Col>
        {this.renderRecentSearch()}
      </Row>
    );
  }

  renderAutocomplete() {
    return (
      <Row className="row-flight">
        <Col xs={12} sm={12} md={6} className="first-column-flight">
          <FlightAutocomplete
            value={this.state.flightOrigin}
            id="autocompleteFlightOrigin"
            placeholder={I18n.translate('home.label.placeholderOrigin')}
            title={I18n.translate('home.label.titleOrigin')}
            searchAirport={searchTerm => {
              return this.props.handleAirportSearch(searchTerm, this.state.flightDestiny);
            }}
            callBack={this.setFlightOrigin}
            ref={e => (this.flightOrigin = e)}
          />
        </Col>
        <div className="azul-icon-airplane" />
        <Col xs={12} sm={12} md={6} className="last-column-flight">
          <FlightAutocomplete
            value={this.state.flightDestiny}
            id="autocompleteFlightDestination"
            placeholder={I18n.translate('home.label.placeholderDestination')}
            title={I18n.translate('home.label.titleDestination')}
            searchAirport={searchTerm => {
              return this.props.handleAirportSearch(searchTerm, this.state.flightOrigin);
            }}
            callBack={this.setFlightDestiny}
            ref={e => (this.flightDestination = e)}
          />
        </Col>
      </Row>
    );
  }

  renderCalendar() {
    return (
      <Row className="row-calendar">
        <Col xs={6} sm={6} md={6} className="first-column-calendar">
          <Calendar
            id="calendarStartDate"
            placeholder={I18n.translate('home.label.placeholderStartDate')}
            title={I18n.translate('home.label.titleStartDate')}
            onFocus={this.handlerFocusStartDate}
            onChange={this.handlerStartDate}
            value={this.state.startDate}
            minDate={this.state.minSelectionDate}
            maxDate={this.state.maxSelectionDate}
            ref={e => (this.startDate = e)}
          />
        </Col>
        <Col xs={6} sm={6} md={6} className="last-column-calendar">
          {this.state.typeTrip === 'roundTrip' ? (
            <Calendar
              id="calendarEndDate"
              placeholder={I18n.translate('home.label.placeholderEndDate')}
              title={I18n.translate('home.label.titleEndDate')}
              onChange={this.handlerEndDate}
              value={this.state.endDate}
              minDate={this.state.startDate || this.state.minSelectionDate}
              maxDate={this.state.maxSelectionDate}
              ref={e => (this.endDate = e)}
            />
          ) : null}
        </Col>
      </Row>
    );
  }

  renderCounters() {
    return (
      <Row>
        <Col md={4} className="col-counterAdult">
          <PassengerCounter
            id="counterAdult"
            labelTop={I18n.translate('home.label.adult')}
            labelBottom={I18n.translate('home.label.limitAdult')}
            maxValue={9}
            minValue={1}
            value={this.state.totalAdults}
            callBack={this.setAdultPassengerCounter}
            ref={e => (this.adultCounter = e)}
          />
        </Col>
        <Col md={4} className="col-counterKid">
          <PassengerCounter
            id="counterKid"
            labelTop={I18n.translate('home.label.kid')}
            labelBottom={I18n.translate('home.label.limitKid')}
            maxValue={9}
            minValue={0}
            value={this.state.totalKids}
            callBack={this.setKidPassengerCounter}
            ref={e => (this.kidCounter = e)}
          />
        </Col>
        <Col md={4} className="col-counterBaby">
          <PassengerCounter
            id="counterBaby"
            labelTop={I18n.translate('home.label.baby')}
            labelBottom={I18n.translate('home.label.limitBaby')}
            maxValue={9}
            minValue={0}
            value={this.state.totalBabys}
            callBack={this.setBabyPassengerCounter}
            ref={e => (this.babyCounter = e)}
          />
        </Col>
      </Row>
    );
  }

  renderCabinType() {
    return (
      <div>
        <Row className="row-cabinCategory">
          <Col xs={13} sm={12} md={12} className="col-cabinCategory">
            <SelectBox
              id="CabinCategory"
              label="home.label.cabinCategory"
              required={false}
              default={this.state.selectCabinCategory}
              values={[ECONOMY_LABEL, BUSINESS_LABEL]}
              changeValue={this.changeValue}
            />
          </Col>
        </Row>
      </div>
    );
  }

  renderButtonSearch() {
    return (
      <Button
        id="btnSearchTickets"
        className="pull-right btn-search center-content button-bottom"
        onClick={this.searchTicket}
        ref={c => (this.btnSearchTickets = c)}>
        <span className="lbl-search">{I18n.translate('home.btn.searchTickets')}</span>
      </Button>
    );
  }

  onTouched(flag) {
    this.setState({ isTouched: flag });
  }

  render() {
    return (
      <div id="searchBox">
        {this.renderTypeTripAndRecentSearchTabletDesktop()}

        {this.renderAutocomplete()}

        {this.state.showAdditionalFields ? this.renderCalendar() : null}

        {this.state.showAdditionalFields ? (
          <Row>
            <Col md={6} className="col-options-flight">
              <Row className="row-counter-select">
                <Col md={6} className="cabin-name">{this.renderCabinType()}</Col>
                <Col md={6} className="first-column-counter container-fluid">
                  {this.renderCounters()}
                </Col>
              </Row>
            </Col>
            <Col md={3} className="col-button-search">
              <Row className="search-options">
                <TypeOfFlight
                  typeOfFlight={this.state.typeOfFlight}
                  typeOfFlightCallback={this.setTypeOfFlight}
                />
              </Row>
            </Col>
          </Row>
        ) : null}

        {this.state.showAdditionalFields ? (
          <Row className="row-relative" >
            <Col md={6} sm={12} xs={12}>
              <a
                onClick={this.toggleCollapse}
                className={this.state.isTouched ||
                  (this.state.companiesIdentity || '-' ) !== '-'  ? 'toggle-btn -active' : 'toggle-btn'}>
                <span>{I18n.translate('home.label.tittleSeachAirCompany')}</span>
                <i className={this.state.openCollapse ? 'arrow-near ant-select-arrow -active' : 'arrow-near ant-select-arrow'}></i>
              </a>
              <Collapse in={this.state.openCollapse}>
                <div>
                  <CompaniesIdentity
                    companiesList={this.state.companiesList}
                    companiesIdentity={this.state.companiesIdentity}
                    isTouched={this.state.isTouched}
                    onTouched={this.onTouched}
                    callbackCompaniesIdentity={this.setCompaniesIdentity}
                    ref="CompaniesIdentity" />
                </div>
              </Collapse>
            </Col>
            <Col>
              {this.state.showAdditionalFields ? this.renderButtonSearch() : null}
            </Col>
          </Row>
        ) : null}

        <InfoModal
          id="modalBusinessValidationInfo"
          message={this.state.messageInfo}
          showModal={this.state.openModal}
          close={this.closeModal}
          ref={c => {
            this.modalBusinessValidationInfo = c;
          }}
        />
      </div>
    );
  }
}

SearchBox.defaultProps = defaultProps;
SearchBox.propTypes = propTypes;

export default SearchBox;



// WEBPACK FOOTER //
// ./src/components/searchBox/SearchBox.jsx